/* eslint-disable react/sort-comp */
/* eslint-disable import/order */
import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { Button, Grid, makeStyles, Typography } from '@material-ui/core'

import BaseFilterModal from '../../../../components/hooks/BaseFilterModal'
import filterStylesComponents from '../../../../assets/filterComponentsStyles'
import colors from '../../../../assets/colors'
import { getAttendanceHistory } from '../../AttendanceActions'
import HistoryItemsTable from './HistoryItemsTable'

const useStyles = makeStyles({
  cardSubTitles: {
    color: colors.primary,
    fontSize: '16px',
    lineHeight: '16px',
    fontWeight: 'bold',
    margin: '10px 0',
  },
  historyContainer: {
    overflowY: 'auto',
    overflowX: 'hidden',
    maxHeight: '500px',
    paddingRight: '8px',
    '&::-webkit-scrollbar': {
      width: '3px',
      height: '8px',
      backgroundColor: colors.graylight,
    },
    '&::-webkit-scrollbar-thumb': {
      background: colors.secondary,
    },
  },
})

export const History = props => {
  const attendanceHistory = useSelector(
    state => state.attendance.attendanceHistory
  )
  const attendance = useSelector(state => state.attendance.editingAttendance)

  const history = useHistory()
  const dispatch = useDispatch()

  const styles = useStyles()
  const filterStyles = filterStylesComponents()

  const { match } = props

  const id = useMemo(() => {
    return match?.params?.id
  }, [match])

  const handleClose = () => {
    history.goBack()
  }

  useEffect(() => {
    if (id) dispatch(getAttendanceHistory(id))
  }, [id])

  return (
    <BaseFilterModal
      open
      title={`Histórico de Alterações | OS: ${
        attendance?.id_laundry_client || id || 'Carregando'
      }`}
      hiddenHelpButton
      handleOpen={handleClose}
    >
      <Grid item xs={12} style={{ width: '500px' }}>
        <Grid container spacing={2}>
          {!attendanceHistory && (
            <Grid item xs={12}>
              <Typography className="MuiDropzoneArea-icon ">
                Carregando histórico...
              </Typography>
            </Grid>
          )}

          {attendanceHistory && attendanceHistory.length === 0 && (
            <Grid item xs={12}>
              <Typography
                style={{
                  textAlign: 'center',
                  color: colors.textSecondary,
                  padding: '20px',
                }}
              >
                Nenhuma alteração encontrada para este atendimento.
              </Typography>
            </Grid>
          )}

          {attendanceHistory && attendanceHistory.length > 0 && (
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={12} className={styles.historyContainer}>
                  <HistoryItemsTable items={attendanceHistory} />
                </Grid>

                <Grid item xs={12} style={{ marginTop: '1em' }}>
                  <Grid container justifyContent="flex-end">
                    <Grid item>
                      <Button
                        className={filterStyles.btnSalvar}
                        onClick={handleClose}
                      >
                        Fechar
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
    </BaseFilterModal>
  )
}

export default History
